import axios from 'axios';
import { API_URL } from '../config/apiConfig';

const formatLocalDate = (value) => {
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const date = new Date(value);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const getTodayWOD = async (affiliateId, date, classType = "WOD") => {
    try {
        const token = localStorage.getItem("token");
        const date1 = formatLocalDate(date);

        const response = await axios.get(`${API_URL}/get-today-wod`, {
            params: {
                date: date1,
                affiliateId,
                classType
            },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching today's WOD:", error);
    }
};

export const getWeekWODs = async (affiliateId, startDate1, classType = "WOD") => {
    try {
        const token = localStorage.getItem("token");
        const startDate = formatLocalDate(startDate1);

        const response = await axios.get(`${API_URL}/get-week-wods`, {
            params: {
                startDate,
                affiliateId,
                classType
            },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching week's WODs:", error);
    }
};

export const getWeekCompeteDays = async (affiliateId, startDateValue) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/get-week-compete-days`, {
            params: {
                startDate: formatLocalDate(startDateValue),
                affiliateId
            },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching week's Compete days:", error);
        throw error;
    }
};

export const saveTodayWOD = async (affiliateId, wodData) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/today-wod`,
            wodData, // ✅ Edasta ainult ühe päeva WOD
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error saving today's WOD:", error);
    }
};

export const applyWODToTrainings = async (affiliateId, date, includeCompete = true, classType = "WOD") => {
    try {
        const token = localStorage.getItem("token");
        const requestBody = { affiliateId, date: formatLocalDate(date), includeCompete, classType };

        const response = await axios.post(`${API_URL}/apply-wod`,
            requestBody, // ✅ Axios teisendab andmed automaatselt JSON-iks
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error applying WOD to trainings:", error);
    }
};

export const moveWODToDate = async (affiliateId, fromDate, toDate, classType = "WOD") => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(
            `${API_URL}/move-wod`,
            {
                affiliateId,
                fromDate: formatLocalDate(fromDate),
                toDate: formatLocalDate(toDate),
                classType
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("❌ Error moving WOD:", error);
        throw error;
    }
};

export const updateTodayWODCoachInfo = async (todayWodId, payload) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(
            `${API_URL}/today-wod/${todayWodId}/coach-info`,
            payload,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error updating WOD coach info:", error);
        throw error;
    }
};

export const deleteTodayWOD = async (todayWodId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(
            `${API_URL}/today-wod/${todayWodId}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting WOD:", error);
        throw error;
    }
};

export const saveCompeteDay = async ({ affiliateId, date, content, source = "manual" }) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/compete-day`,
            {
                affiliateId,
                date: formatLocalDate(date),
                content,
                source
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error saving Compete day:", error);
        throw error;
    }
};

export const moveCompeteDay = async ({ affiliateId, fromDate, toDate }) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/move-compete-day`,
            {
                affiliateId,
                fromDate: formatLocalDate(fromDate),
                toDate: formatLocalDate(toDate)
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error moving Compete day:", error);
        throw error;
    }
};

export const applyCompeteDay = async ({ affiliateId, date }) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/apply-compete-day`,
            {
                affiliateId,
                date: formatLocalDate(date)
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error applying Compete day:", error);
        throw error;
    }
};

export const hasCompeteForDay = async ({ affiliateId, date }) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/has-compete-for-day`, {
            params: {
                affiliateId,
                date: formatLocalDate(date)
            },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error checking Compete day:", error);
        throw error;
    }
};

export const searchDefaultWODs = async (query) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/search-default-wods`, {
            params: {
                q: query
            },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error searching default WODs:", error);
    }
};

export const getTodayWODWorkoutImage = async (todayWodId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/today-wod/${todayWodId}/workout-image`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) return null;
        console.error("❌ Error fetching today WOD workout image:", error);
        return null;
    }
};

export const uploadTodayWODWorkoutImage = async (todayWodId, imageFile) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("image", imageFile);

    const response = await axios.post(`${API_URL}/today-wod/${todayWodId}/workout-image`, formData, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });

    return response.data;
};

export const deleteTodayWODWorkoutImage = async (todayWodId) => {
    const token = localStorage.getItem("token");
    const response = await axios.delete(`${API_URL}/today-wod/${todayWodId}/workout-image`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });
    return response.data;
};